import { render, staticRenderFns } from "./ConnectUniversity.vue?vue&type=template&id=fd9fae7c&scoped=true"
import script from "./ConnectUniversity.vue?vue&type=script&lang=js"
export * from "./ConnectUniversity.vue?vue&type=script&lang=js"
import style0 from "./ConnectUniversity.vue?vue&type=style&index=0&id=fd9fae7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9fae7c",
  null
  
)

export default component.exports